// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2ZMy9","header":"ReportDetails_header__3qNl3","title":"ReportDetails_title__Nwroc","left":"ReportDetails_left__j4L6P"};